import React, { useMemo } from "react";

import RotatingTextAnimation from "@/components/ui/RotatingTextAnimation";

interface SearchingWranglerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  hideText?: boolean;
}

const SIZE_CONFIG = {
  sm: "h-32 w-32",
  md: "h-40 w-40",
  lg: "h-48 w-48",
};

export const SearchingWrangler: React.FC<SearchingWranglerProps> = ({
  size = "lg",
  className = "",
  hideText = false,
}) => {
  const rotatingPhrases = useMemo(
    () => [
      "Summoning your prompts...",
      "Wrangling some workflows...",
      "Herding datasets...",
      "Consulting the oracles...",
      "Running the numbers...",
      "Digging through the archives...",
    ],
    [],
  );

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <img
        src="/looped_searching_wrangler.gif"
        alt="Searching..."
        className={` ${SIZE_CONFIG[size]}`}
        style={{ imageRendering: "auto" }}
      />
      {!hideText && (
        <RotatingTextAnimation
          phrases={rotatingPhrases}
          interval={1000}
          shuffle
          disableBlur
          className="text-sm text-gray-600"
        />
      )}
    </div>
  );
};
